<template>
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M32 16C32 19.5221 30.8378 22.9459 28.6937 25.7402C26.5495 28.5345 23.5432 30.5432 20.1411 31.4548C16.739 32.3664 13.1311 32.1299 9.87707 30.7821C6.62303 29.4342 3.90467 27.0503 2.14359 24C0.38252 20.9497 -0.32285 17.4036 0.136882 13.9116C0.596614 10.4196 2.19576 7.17683 4.68629 4.68629C7.17683 2.19576 10.4196 0.596615 13.9116 0.136882C17.4036 -0.32285 20.9497 0.382519 24 2.14359L22.2434 5.18616C19.8629 3.81178 17.0954 3.26129 14.3702 3.62008C11.6449 3.97886 9.1142 5.22687 7.17053 7.17054C5.22687 9.1142 3.97886 11.6449 3.62008 14.3702C3.26129 17.0954 3.81178 19.8629 5.18616 22.2434C6.56054 24.6239 8.682 26.4843 11.2215 27.5363C13.7611 28.5882 16.5767 28.7727 19.2318 28.0613C21.8869 27.3498 24.2331 25.7822 25.9064 23.6015C27.5797 21.4207 28.4867 18.7488 28.4867 16H32Z"
      fill="white" />
  </svg>
</template>
<style scoped>
@keyframes rotating {
  from {
    -ms-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  to {
    -ms-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

svg {
  -webkit-animation: rotating 2s linear infinite;
  -moz-animation: rotating 2s linear infinite;
  -ms-animation: rotating 2s linear infinite;
  -o-animation: rotating 2s linear infinite;
  animation: rotating 2s linear infinite;
}
</style>
